export default "__VITE_ASSET__DigQZ4Uh__"